const KNOWN_MODULES = ['impactMeten', 'personas', 'housevisits', 'portfolio']

const parseDeeplink = (search) => {

    const defaults = {
        partnerSlug: null,
        networkCompagnyID: null,
        moduleSlugs: [],
        baseEnabled: true,
    }

    if (!search) return defaults

    const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)

    const partnerRaw = params.get('partner')
    const partnerSlug = partnerRaw ? partnerRaw.toLowerCase() : null

    // CompagnyID's zijn case-sensitive in Firestore — niet lowercasen.
    const networkRaw = params.get('network')
    const networkTrimmed = networkRaw ? networkRaw.trim() : ''
    const networkCompagnyID = networkTrimmed || null

    const modulesRaw = params.get('modules') || ''
    const moduleSlugs = modulesRaw
        .split(',')
        .map((slug) => slug.trim())
        .filter((slug) => KNOWN_MODULES.includes(slug))
        .filter((slug, index, all) => all.indexOf(slug) === index)

    const baseRaw = params.get('base')
    const baseEnabled = baseRaw === 'false' ? false : true

    return {
        partnerSlug: partnerSlug || null,
        networkCompagnyID,
        moduleSlugs,
        baseEnabled,
    }

}

export default parseDeeplink
